import { Link, Navigate, useLocation, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import {
  accountFromEnvelope,
  getBusinessAccount,
} from '../features/signup-setup/signupSetupApi.js';
import { accountSlugMatches } from '../shell/businessRole.js';

/** Optional `/a/:accountSlug/*` parent — verifies the session account, then continues unprefixed. */
export function AccountScopeLayout() {
  const { accountSlug, '*': rest } = useParams();
  const location = useLocation();
  const accountQuery = useQuery({
    queryKey: ['business', 'account', 'scope'],
    queryFn: () => getBusinessAccount(),
    staleTime: 60_000,
  });

  if (accountQuery.isLoading) {
    return <p role="status">Checking account…</p>;
  }

  if (accountQuery.isError) {
    return (
      <p role="alert" className="mb-field text-negative">
        {(accountQuery.error as Error)?.message ?? 'Could not verify this account link.'}
      </p>
    );
  }

  const account = accountFromEnvelope(accountQuery.data);
  if (account && !accountSlugMatches(accountSlug, account)) {
    return (
      <div className="b01-scope-mismatch" role="status">
        <p>This link is for a different business account than the one signed in.</p>
        <p>
          <Link to="/">Continue with this account</Link>
        </p>
      </div>
    );
  }

  const dest = `/${rest ?? ''}${location.search}${location.hash}`;
  return <Navigate to={dest === '//' ? '/' : dest} replace />;
}
